import request from '@/utils/request'
//获取发货地址
export function getAddresses (params) {
  return request({
    url: '/companyAddresses',
    method: 'get',
    params: params
  })
}
//新增发货地址
export function addAddresses (data) {
  return request({
    url: '/companyAddresses',
    method: 'post',
    data: data
  })
}
//修改地址
export function updateAddresses (data) {
  return request({
    url: '/companyAddresses',
    method: 'post',
    data: data
  })
}
//删除发货地址
export function deleteAddresses (id) {
  return request({
    url: '/companyAddresses/' + id,
    method: 'delete',
  })
}
// 修改为默认地址
export function updateDefaultAddress (data) {
  return request({
    url: '/companyAddresses/updateDefaultAddress',
    method: 'post',
    data: data
  })
}

//获取发货地址
export function getDefault (params) {
  return request({
    url: '/companyAddresses/default',
    method: 'get',
    params: params
  })
}



// WEBPACK FOOTER //
// ./src/api/addManagement.js